// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1CHay","buttons":"RemoveExpirationActionButtons_buttons__3j3QO"};